// YouTube Iframe API Player States enum
// Reference:
// https://developers.google.com/youtube/iframe_api_reference#:~:text=of%20the%20player.-,Possible%20values%20are%3A,-%2D1%20%E2%80%93%20unstarted
const playerStates = {
  ENDED: 0,
  PAUSED: 2,
};

const defaultOptions = {
  activeClass: 'is-active',
  wrapperClass: 'pip-wrapper',
  placeholderClass: 'pip-placeholder',
};

class YTPictureInPicture {
  constructor(videoElement, player, options) {
    this.options = {
      ...defaultOptions,
      ...options,
    };

    this.videoElement = videoElement;
    this.player = player;
    this.isActive = false;

    this.createWrapper();
    this.createControls();

    let intersectionOptions = {
      threshold: 0.1,
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.deactivate(false);
          return;
        }

        this.activate();
      });
    };

    const observer = new IntersectionObserver(callback, intersectionOptions);

    observer.observe(this.placeholder);

    window.dispatchEvent(new Event('YTPictureInPicture_initialized'));
  }

  createControls() {
    this.closeBtn = document.createElement('button');
    this.closeBtn.classList.add('pip-close-btn');
    this.closeBtn.setAttribute('type', 'button');
    this.closeBtn.addEventListener('click', this.deactivate.bind(this, true));
    this.wrapper.append(this.closeBtn);
  }

  createWrapper() {
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add(this.options.wrapperClass);
    this.placeholder = document.createElement('div');
    this.placeholder.classList.add(this.options.placeholderClass);
    const paddingBottom =
      this.videoElement.offsetHeight / this.videoElement.offsetWidth;
    this.placeholder.style.paddingBottom = `${paddingBottom * 100}%`;
    this.placeholder.append(this.wrapper);
    this.videoElement.parentNode.insertBefore(
      this.placeholder,
      this.videoElement
    );
    this.wrapper.appendChild(this.videoElement);
  }

  activate() {
    if (this.player.getPlayerState() === playerStates.ENDED 
      || this.player.getPlayerState() === playerStates.PAUSED) return;
    this.wrapper.classList.add(this.options.activeClass);
    this.isActive = true;
  }

  deactivate(shouldPause = false) {
    this.wrapper.classList.remove(this.options.activeClass);
    this.isActive = false;
    if (shouldPause && this.player && this.player.pauseVideo) {
      this.player.pauseVideo();
    }
  }
}

// expose in window
window.YTPictureInPicture = YTPictureInPicture;

export default YTPictureInPicture;
